'use client';
import styled from 'styled-components';
import { StarRating as SharedStarRating } from '@web/components';

export const Wrapper = styled.div``;

export const StyledForm = styled.form`
  padding-bottom: ${props => props.theme.spacing(15)};
  width: 100vw;
  @media ${props => props.theme.laptop} {
    padding-bottom: ${props => props.theme.spacing(23)};
  }
`;

export const StyledRecommendedPlanContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  background-color: ${props => props.theme.colors.background.base};

  fieldset {
    border: none;
    margin: 0;
    padding: 0;
    min-width: unset;
  }

  @media ${props => props.theme.laptop} {
    flex-direction: row;
    justify-content: center;
  }
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  @media ${props => props.theme.laptop} {
    flex: 1;
    padding: ${props => props.theme.spacing(6, 16)};
    margin: ${props => props.theme.spacing(0)};
    align-items: flex-start;
  }
`;

export const ProductSelectorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  position: relative;
  top: 0;
  padding: ${props => props.theme.spacing(3, 0, 6)};
  color: ${props => props.theme.colors.text.primary};

  @media ${props => props.theme.laptop} {
    padding: ${props => props.theme.spacing(4, 0, 6)};
  }
`;

export const ProductSelectorContainerDesktop = styled.div`
  display: none;

  @media ${({ theme }) => theme.laptop} {
    display: block;
    padding-bottom: ${props => props.theme.spacing(2)};
  }
`;

export const ProductSelectorContainerMobile = styled.div`
  display: block;
  padding: ${props => props.theme.spacing(4, 0, 2)};

  @media ${({ theme }) => theme.laptop} {
    display: none;
  }
`;

export const DescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  margin: ${props => props.theme.spacing(2, 4, 0)};
  gap: ${props => props.theme.spacing(3)};

  @media ${({ theme }) => theme.laptop} {
    margin: ${props => props.theme.spacing(6, 0, 0)};
  }
`;

export const Headline = styled.p`
  ${({ theme }) => theme.typography.heading2}
  text-align: left;
  font-size: 2.25rem;

  @media ${({ theme }) => theme.laptop} {
    font-size: 3.375rem;
  }
`;

export const ProductCardContainer = styled.div`
  max-width: 100%;
  margin: auto;
  text-align: center;

  @media ${({ theme }) => theme.laptop} {
    margin: 0;
  }
`;

export const PlanContainer = styled.div`
  margin: auto;
  margin-top: ${props => props.theme.spacing(3)};
  width: fit-content;
  max-width: 360px;
  display: flex;
  flex-direction: column;
  ${props => props.theme.typography.heading4};
  padding-bottom: ${props => props.theme.spacing(10)};
  @media ${({ theme }) => theme.tablet} {
    margin-top: ${props => props.theme.spacing(5)};
    padding-bottom: ${props => props.theme.spacing(10)};
  }
`;

export const CarouselSectionContainer = styled.div`
  flex: 1;
  display: flex;
  align-content: center;
  justify-content: flex-end;
`;

export const DesktopImageContainer = styled.div`
  display: none;

  @media ${props => props.theme.laptop} {
    display: flex;
    width: 40vw;
    height: 40vw;
    max-height: 500px;
    max-width: 500px;
    margin: ${props => props.theme.spacing(10, 0, 0, 25)};
    img {
      object-fit: cover;
      min-height: 100%;
      width: 100%;
    }
  }
`;

export const MobileImageContainer = styled.div`
  margin: ${props => props.theme.spacing(4, 0, 0, 4)};
  margin-left: auto;
  overflow: hidden;
  width: 96vw;
  max-width: 96vw;

  img {
    height: 100%;
    max-width: 95vw;
    object-fit: cover;
  }
  @media ${props => props.theme.laptop} {
    display: none;
  }
`;

export const Description = styled.p`
  ${props => props.theme.typography.body};
  padding-bottom: ${props => props.theme.spacing(1)};
  text-wrap: wrap;
  text-align: left;

  @media ${({ theme }) => theme.laptop} {
    max-width: 65%;
    padding: ${props => props.theme.spacing(2, 0)};
  }
`;

export const SelectionText = styled.span`
  ${props => props.theme.typography.body};
  color: ${props => props.theme.colors.text.tertiary};
`;

export const RatingContainer = styled.div`
  cursor: pointer;
`;

export const StarRating = styled(SharedStarRating)`
  display: flex;
  align-items: center;
  color: ${props => props.theme.colors.text.primary};
  font-size: 18px;
  letter-spacing: 0.18px;
  gap: ${props => props.theme.spacing(1)};
  &::before {
    background-color: ${props =>
      props.theme.colors.get(props.$backgroundColor, '#dbbd68')};
    font-size: inherit;
  }
`;

export const ReviewsText = styled.p`
  color: ${props => props.theme.colors.text.link};
  font-size: 18px;
  letter-spacing: 0.18px;
  text-decoration: underline;
`;

export const IconButtonContainer = styled.div`
  z-index: 101;
  display: flex;
  position: fixed;
  top: 17px;
  left: 12px;
  gap: ${props => props.theme.spacing(4)};
  max-width: 350px;
  width: auto;
  button {
    border: none;
  }
  @media ${props => props.theme.tabletL} {
    margin-bottom: ${props => props.theme.spacing(2)};
  }
`;

export const CalloutsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: ${props => props.theme.spacing(8, 0)};

  @media ${props => props.theme.laptop} {
    justify-content: flex-start;
    margin: ${props => props.theme.spacing(8, 0, 8)};
  }
`;

export const CalloutContainer = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing(2)};
  margin: ${props => props.theme.spacing(0, 4, 2, 0)};
`;

export const CallloutText = styled.p`
  ${props => props.theme.typography.body};
  color: ${props => props.theme.colors.secondary.plum};
  text-wrap: nowrap;
  text-align: left;
`;

export const CollapsedPlansContainer = styled.div`
  padding-bottom: ${props => props.theme.spacing(10)};
`;

export const TestimonialScrollContainer = styled.div`
  scroll-margin-top: 92px; /*the height of navigation bar*/
`;

export const SectionHeader = styled.h5`
  text-align: left;
  ${props => props.theme.typography.heading5};
  padding: ${props => props.theme.spacing(5, 0)};
`;
